module.exports = __webpack_public_path__ + "static/media/focus-style-fonts.00261249.png";